import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'
import { PackEntityConstantEnumsVO } from '../Type/PackEntityConstantEnumsVO'

/**
				 *	查询枚举类常量
				
				*/

export function constantenums(options: IRequestOptionsWithPass): Promise<PackEntityConstantEnumsVO>
export function constantenums(
	options?: IRequestOptions,
): Promise<PackEntityConstantEnumsVO extends { msg: unknown } ? PackEntityConstantEnumsVO['msg'] : undefined>
export function constantenums(options: IRequestOptionsWithPass | IRequestOptions = {}) {
	return net('/frontApi/common/constant/enums', {
		method: 'post',

		...(options || {}),
	})
}
